module.exports = __webpack_public_path__ + "img/logo.3fb47576.png";